// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__esliK","header":"styles_header__nQN9l","body":"styles_body__DBo1w","submit":"styles_submit__Y5oGc"};